PF.RightPanel = class RightPanel extends PF.Widget
	{
	get options()
		{
		return {
			page: undefined
		};
		}

	get template()
		{
		// language=HTML
		return `
			<div id="right-panel" class="panel panel-right panel-cover" style="overflow: hidden;">
				<div class="navbar">
					<div class="navbar-inner">
						<div class="title"></div>
					</div>
				</div>

				<div style="height: calc(100% - 64px);overflow: auto;">

				</div>

			</div>
		`;
		}


	init()
		{
		super.init();
		this.dom.load(this.template, 'panel');
		this.page.on('afterIn', () => this.create());
		this.page.on('beforeOut', () => this.destroy());
		}

	create()
		{
		PF.Dom.Node.findOne('#app').append(this.dom.panel);
		PF.Dom.Node.findOne('#app').addClass('has-right-panel');
		if (this.f7panel !== undefined)
			{
			this.destroy();
			}
		if (app.f7.panel.right !== undefined)
			{
			app.f7.panel.right.destroy();
			this.dom.panel.remove();
			}

		this.f7panel = app.f7.panel.create({
			el: this.dom.panel.node,
			side: 'right',
			effect: 'cover',
			visibleBreakpoint: app.f7Config.panel.rightBreakpoint,
		});

		// this.dom.panel.css('order', '3');
		// this.page.dom.pageContent.addClass('right-panel');

		if (PF.Dom.Node.findOne('#app').width() > app.f7Config.panel.rightBreakpoint)
			{
			this.f7panel.open();
			}

		// this.initForm();
		}

	destroy()
		{
		this.f7panel.destroy();
		PF.Dom.Node.findOne('#app').removeClass('has-right-panel');
		}


	};

